(function() {
  'use strict';

  // 1. The Cleaner Function: fast and simple
  function fixTriplePrice() {
    // Select all subscription price boxes
    const priceDivs = document.querySelectorAll('.shopify_subscriptions_in_widget_price, .allocation_price');
    
    priceDivs.forEach(div => {
      // Get the text, e.g., "4,500.00 4,500.00 4,500.00"
      const text = div.innerText.trim();
      
      // If it contains spaces, it might be duplicated
      if (text.includes(' ') && text.length > 5) {
         // Split by space
         const parts = text.split(/\s+/);
         
         // If we have 3 parts and part 1 equals part 2 (Duplication detected)
         if (parts.length >= 2 && parts[0] === parts[1]) {
             // Force it to show only the first part
             div.innerText = parts[0];
         }
      }
    });
  }

  // 2. Run it immediately
  fixTriplePrice();

  // 3. Run it again after 1 and 3 seconds (to catch the app loading)
  setTimeout(fixTriplePrice, 1000);
  setTimeout(fixTriplePrice, 3000);

  // 4. Lightweight Observer (Only watches for specific attribute changes, not everything)
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    mutations.forEach((m) => {
      // Only run if a new node was added (the widget loaded)
      if (m.addedNodes.length) shouldRun = true;
    });
    if (shouldRun) fixTriplePrice();
  });

  // Start observing
  const productForm = document.querySelector('.product-form') || document.body;
  observer.observe(productForm, { childList: true, subtree: true });

})();